<template>
  <b-table
    :items="items"
    :fields="fields"
    show-empty
    :empty-text="$t('GERAL.NENHUM_REGISTRO')"
    head-variant="light"
    stacked="md"
    striped
    responsive
    hover
    @sort-changed="aoMudarOrdenacao"
  >
    <template #cell(disciplinaCurriculo)="item">
      <p>{{ nomeDisciplina(item) }}</p>
    </template>
    <!-- SE FOR UMA EDIÇÃO, VAI ABRIR OS CAMPOS PARA EDIÇÃO -->
    <template v-if="editar.exibir" #cell(disciplinaCurriculoId)="item">
      <input-select-search
        ref="disciplinaCurriculoId"
        :options="disciplinas"
        v-model="item.item.disciplinaCurriculoId"
        required
      />
    </template>
    <template v-if="editar.exibir" #cell(faltas)="item">
      <input-number
        ref="faltas"
        v-model="item.item.faltas"
        removeSpecialChars
        removeWhiteSpaces
        required
      />
    </template>
    <template v-if="editar.exibir" #cell(cargaHoraria)="item">
      <input-number
        ref="cargaHoraria"
        v-model="item.item.cargaHoraria"
      />
    </template>
    <template #cell(media)="item">
      <template v-if="editar.exibir">
        <input-number
          v-if="!isParecerDescritivo(item.item)"
          ref="media"
          v-model="item.item.media"
          required
        />
        <input-select
          v-else
          ref="statusParecerDescritivo"
          v-model="item.item.statusParecerDescritivo"
          :options="opcoesStatusParecerDescritivo"
          value-field="value"
          text-field="text"
          required
        />
      </template>
      <template v-else>
        {{ textoMediaOuParecer(item.item) }}
      </template>
    </template>
    <template #cell(acoes)="item">
      <template v-if="editar.exibir">
        <b-button variant="primary" @click="atualizar(item.item)">
          {{ $t('GERAL.ATUALIZAR') }}
        </b-button>
      </template>
      <template v-else>
        <b-dropdown variant="outline-default">
          <b-dropdown-item @click="habilitarEdicao(item.item)">
            {{ $t('GERAL.EDITAR') }}
          </b-dropdown-item>
          <b-dropdown-item @click="confirmarExclusao(item)">
            {{ $t('GERAL.EXCLUIR') }}
          </b-dropdown-item>
        </b-dropdown>
      </template>
    </template>
  </b-table>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

// Services:
import CurriculoEscolarService from '@/common/services/curriculo-escolar/curriculo-escolar.service';

// Constants:
const ID_PARECER_DESCRITIVO = '17ebab43-5404-4963-9d37-2cad19464866';

// Components:
import { InputNumber, InputSelectSearch, InputSelect } from '@/components/inputs';

export default {
  props: {
    items: { type: Array, default: Array },
    curriculoEscolarId: { type: String, default: String },
    disciplinas: { type: Array, default: Array },
  },
  components: {
    InputNumber,
    InputSelectSearch,
    InputSelect,
  },
  data() {
    return {
      opcoesStatusParecerDescritivo: [
        { value: 'APR', text: 'Aprovado' },
        { value: 'RPV', text: 'Reprovado' },
      ],
      fields: [
        {
          key: 'disciplinaCurriculo',
          label: 'Disciplina',
          sortable: true,
        },
        {
          key: 'faltas',
          label: 'Faltas',
          sortable: true,
        },
        {
          key: 'cargaHoraria',
          label: 'Carga Horária',
          sortable: true,
        },
        {
          key: 'media',
          label: 'Média',
          sortable: true,
        },
        {
          key: 'acoes',
          label: 'Ações',
        },
      ],
      editar: {
        exibir: false,
        disciplinas: [],
      },
    };
  },
  methods: {
    isParecerDescritivo(item) {
      const id = item.disciplinaCurriculoId ?? item.disciplinaCurriculo?.id;
      return id === ID_PARECER_DESCRITIVO;
    },
    /** Retorna o valor do enum (APR/RPV) aceitando regra nova e antiga (media "Aprovado"/"Reprovado"). */
    getStatusParecerDescritivo(item) {
      const s = item.statusParecerDescritivo || item.StatusParecerDescritivo;
      if (s === 'APR' || s === 'RPV') return s;
      const media = item.media != null ? String(item.media).trim().toLowerCase() : '';
      if (media === 'aprovado') return 'APR';
      if (media === 'reprovado') return 'RPV';
      return null;
    },
    textoMediaOuParecer(item) {
      if (this.isParecerDescritivo(item)) {
        const status = this.getStatusParecerDescritivo(item);
        if (!status) return '—';
        const opcao = this.opcoesStatusParecerDescritivo.find((o) => o.value === status);
        return opcao ? opcao.text : status;
      }
      return item.media != null && item.media !== '' ? item.media : '—';
    },
    nomeDisciplina(item) {
      return item.item.id
        ? item.item.disciplinaCurriculo.descricao
        : this.procuraDescricao(item);
    },
    procuraDescricao(item) {
      for (var i = 0; i < this.disciplinas.length; i++) {
        if (this.disciplinas[i]['id'] == item.item.disciplinaCurriculoId) {
          return this.disciplinas[i]['descricao'];
        }
      }
      return 'Erro ao buscar nome da disciplina.';
    },
    // FUNÇÕES CRUD:
    habilitarEdicao() {
      // Normaliza registros antigos: Parecer Descritivo que veio com media "Aprovado"/"Reprovado"
      this.items.forEach((item) => {
        if (this.isParecerDescritivo(item) && !item.statusParecerDescritivo) {
          const status = this.getStatusParecerDescritivo(item);
          if (status) this.$set(item, 'statusParecerDescritivo', status);
        }
      });
      this.editar.exibir = true;
    },
    fecharEdicao() {
      this.editar.exibir = false;
    },
    atualizar(item) {
      // Validação do formulário
      if (!this.validarItem(item)) {
        return;
      }

      // Prepara o objeto para envio
      const itemParaEnviar = { ...item };
      itemParaEnviar.entidadeId = this.curriculoEscolarId;

      // Se for Parecer Descritivo: garante statusParecerDescritivo (incluindo regra antiga) e remove media
      if (this.isParecerDescritivo(item)) {
        itemParaEnviar.statusParecerDescritivo = this.getStatusParecerDescritivo(item);
        if (itemParaEnviar.media !== undefined) {
          delete itemParaEnviar.media;
        }
      } else {
        // Se não for Parecer Descritivo, remove statusParecerDescritivo
        if (itemParaEnviar.statusParecerDescritivo !== undefined) {
          delete itemParaEnviar.statusParecerDescritivo;
        }
      }

      if (item.id) {
        this.$store.dispatch(START_LOADING);
        CurriculoEscolarService.atualizarDisciplina(itemParaEnviar)
          .then(() => {
            mensagem.sucesso(
              this.$t('GERAL.SUCESSO'),
              'Disciplina atualizada!'
            );
            this.fecharEdicao();
            this.$emit('atualizado');
          })
          .catch((err) => {
            mensagem.showErrors(err);
          })
          .finally(() => {
            this.$store.dispatch(STOP_LOADING);
          });
      } else {
        this.fecharEdicao();
      }
    },
    validarItem(item) {
      // Valida campos obrigatórios
      if (!item.disciplinaCurriculoId) {
        mensagem.erro('Erro', 'É necessário selecionar uma disciplina.');
        return false;
      }

      if (item.faltas === null || item.faltas === undefined || item.faltas === '') {
        mensagem.erro('Erro', 'É necessário informar as faltas.');
        return false;
      }

      if (item.cargaHoraria === null || item.cargaHoraria === undefined || item.cargaHoraria === '') {
        mensagem.erro('Erro', 'É necessário informar a carga horária.');
        return false;
      }

      if (this.isParecerDescritivo(item)) {
        if (!this.getStatusParecerDescritivo(item)) {
          mensagem.erro('Erro', 'É necessário selecionar uma situação (Aprovado/Reprovado).');
          return false;
        }
      } else {

        if (item.media === null || item.media === undefined || item.media === '') {
          mensagem.erro('Erro', 'É necessário informar a média.');
          return false;
        }
      }

      return true;
    },
    async confirmarExclusao(item) {
      const respostaExclusao = await mensagem.confirmacao(
        this.$t('ACADEMICO.CONFIRMAR_EXCLUIR_DISCIPLINA'),
        this.$t('ACADEMICO.AVISO_NAO_PODE_DESFAZER_ACAO')
      );
      respostaExclusao.isConfirmed ? this.excluir(item) : {};
    },
    excluir(item) {
      if (!item.item.id) return this.items.splice(item.index, 1);

      this.$store.dispatch(START_LOADING);
      CurriculoEscolarService.excluirDisciplina(item.item)
        .then(() => {
          this.items.splice(item.index, 1);
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), 'Disciplina excluída!');
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    aoMudarOrdenacao({ sortBy, sortDesc }) {
      let campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy)
      let ordem = sortDesc
      this.$emit('alterar-ordenacao', campoOrdenado, ordem);
    },
  },
};
</script>
